module.exports = __webpack_public_path__ + "img/promotion-1.7c253d66.png";